export default function (context, val) {
  let old = context.state.form.PaymentOperationID;
  context.commit('set_form', {
    PaymentOperationID: val,
  });
  if (!context.rootGetters['dictionary/paymentOperation/getById']) return;
  let operation = context.rootGetters['dictionary/paymentOperation/getById'](val);
  if (context.state.form.AgreementCodes.length && !operation.OperationType) {
    window.app.$confirm('Выбранная платёжная операция не относится к операциям, совершаемым по путёвкам. Прикреплённые путёвки будут удалены из платежа. Изменить платёжную операцию?', 'Внимание!', {
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
      type: 'warning',
      center: true
    }).then(() => {
      window.app.$message({
        type: 'success',
        message: 'Платёжная операция изменена!'
      });
      context.commit('set_form', {
        PaymentOperationID: val,
      });
      context.commit('set_form', {
        AgreementCodes: [],
        ContragentID: null,
        ContragentName: '',
        PartnerLegalEntityId: null,
      });
      context.state.agreements.list = [];
      edit(context, true);
    }).catch(() => {
      context.commit('set_form', {
        PaymentOperationID: old,
      });
      window.app.$message({
        type: 'info',
        message: 'Платёжная операция не изменилась!'
      });
    });
  } else {
    context.commit('set_form', {
      PaymentOperationID: val,
    });
    edit(context);
  }


  function edit(context, a) {
    context.commit('set_form', {
      CategoryId: operation.PaymentTypeCategoryId,
      PaymentTypeId: operation.PaymentTypeId,
    });

    context.dispatch('change_CategoryId', operation.PaymentTypeCategoryId);

    let cTypes = context.rootGetters['dictionary/contragentType/list'](val);
    let cType = cTypes.filter(i => {
      return i.value === context.state.form.ContragentType;
    })[0];
    cType = cType ? cType : cTypes[0];
    if (cType.value !== context.state.form.ContragentType) {
      if ((context.getters.computed_hiddenClient||context.getters.computed_hiddenOperator) && !a) context.dispatch('change_ContragentType', 7);
      else context.dispatch('change_ContragentType', cType.value);
    }
    context.dispatch('agreement_comment');

  }
}
